import React, { SVGProps } from "react";
import Icon from "./Icon/Icon";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 15.7 15.7"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M2.3 13.4c-3.1-3.1-3.1-8.1 0-11.1s8.1-3.1 11.1 0 3.1 8.1 0 11.1c-3 3.1-8 3.1-11.1 0M12.7 3C10 .3 5.7.3 3 3s-2.7 7 0 9.7 7 2.7 9.7 0 2.7-7 0-9.7M6.8 9.8v-7h2v7zm0 3.1v-2h2v2z" />
  </svg>
);
const SvgExclamationCircle = (
  props: Omit<React.ComponentProps<typeof Icon>, "SvgIcon" | "name">
) => <Icon SvgIcon={SvgIcon} name="exclamation-circle" {...props} />;
export default SvgExclamationCircle;
